import { Editor, Node, Range } from 'slate';
import { ReactEditor } from 'slate-react';
import isNodeTextEqualToWindowSelection from 'components/text-editor/hooks/use-custom-editor/actions/is-node-text-equal-to-window-selection';
import { notEmpty } from 'utils/js';

export type GetSelectedTextSnippetNode = (
  selection?: Range,
) => CustomNode | null;

type CustomNode = Node & { annotationId: string };

export default function getSelectedTextSnippetNode(
  editor: ReactEditor,
): GetSelectedTextSnippetNode {
  return function (selection?: Range): CustomNode | null {
    const at = (selection ?? editor.selection) as Range;

    const match = (node) =>
      Boolean((node.name || node.isLink) && node.annotationId);

    if (at) {
      const result = Array.from(Editor.nodes(editor, { at, match }));

      if (notEmpty(result)) {
        const [selectedSnippet] =
          result.find(([node]) =>
            isNodeTextEqualToWindowSelection(editor)(node),
          ) || [];

        return (selectedSnippet as any) ?? null;
      }
    }

    return null;
  };
}
